define('controllers/usermanager',['require'],function(require) {
    return function () {
        var trStateProv, hdnState, hdnStateProvs, ddlState_Province, ddlCountry;

        window.fillStates = function(CountryID) {
            if (CountryID != null) {
                trStateProv.hide();
                var data = hdnStateProvs.value;
                var JSONStates = JSON.parse(data);
                var ddl = document.getElementById("ddlState_Province");
                ddl.innerHTML = "";

                ddl.options[optionIndex] = new Option("[Select A State/Province]", "");
                var optionIndex = 1;
                for (var i = 0; i < JSONStates.length; i++) {
                    if (JSONStates[i].CountryID == CountryID) {
                        ddl.options[optionIndex] = new Option(JSONStates[i].Name, JSONStates[i].StateProvinceID);
                        optionIndex++;
                    }
                }
                trStateProv.show();
            } else {
                trStateProv.hide();
            }
        }

        window.selectState = function(stateName) {
            if (stateName == null) { //select option, if exists in state dropdown
                for (var i = 0; i < ddlState_Province.length; i++) {
                    if (ddlState_Province.options[i].innerHTML == hdnState.value) {
                        ddlState_Province.options[i].selected = true;
                        break;
                    }
                }
            }
            else { //put selected state in hdn field to retrieve on server
                hdnState.value = stateName;
            }
        }

        $(function () {
            trStateProv = $("#trStateProv");
            hdnState = document.getElementById("hdnState");
            hdnStateProvs = document.getElementById("hdnStateProvs");
            ddlCountry = document.getElementById("ddlCountry");
            ddlState_Province = document.getElementById("ddlState_Province");

            var modeIsPersonalInfo = ddlCountry != null; //old control that is doing too much, so just patch it. this page will be rewritten at some point
            if (modeIsPersonalInfo) {
                fillStates(ddlCountry.options[ddlCountry.selectedIndex].value);
                selectState(null);

                $("#txtAirport").autocomplete({
                    minLength: 0,
                    source: "/public/AirPortSearchAJAX.aspx",
                    search: function () {
                        $(this).addClass('working');
                    },
                    response: function () {
                        $(this).removeClass('working');
                    },
                    focus: function (event, ui) {
                        $(this).val(ui.item.FAA);
                        return false;
                    },
                    select: function (event, ui) {
                        $(this).val(ui.item.FAA);
                        return false;
                    }
                })
                .data("uiAutocomplete")._renderItem = function (ul, item) {
                    return $("<li>")
                        .data("ui-autocomplete-item", item)
                        .append("<a>{0} -- {1} -- {2}, {3}</a>".format(item.FAA, item.AirportName, item.City, item.State))
                        .appendTo(ul);
                };

                Utilities.setDefaultButton($("#tblMemberInformation"), $("#btnUserSave"));

                //when customer id changes, indicate that we're posting back to the server to load the customer-specific controls.
                $('#ddlCustomerID').on('change', function () {
                    $('#loadingCustomerFields').show();
                });

                $(".datePicker").datepicker();
            }
        });
    };
});

